export default __webpack_public_path__ + "static/pro-1-b6ea992b2ba3c2ac29015f71fd7e3500.jpg";